import React from 'react';
import { useTranslation } from 'react-i18next';

import { Case } from '../../../../shared/api/hscan/case';
import { Spacer } from '../../common/components/Spacer';
import { SectionHeading } from '../../common/components/styledComponents';

import { RequestCdTable } from './RequestCdTable';

interface RequestImageSectionProps {
  cases: Case[];
}
export const RequestImageSection = ({ cases }: RequestImageSectionProps) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.imageList.cd.request',
  });

  return (
    <>
      <SectionHeading>{t('title')}</SectionHeading>
      <Spacer height="10px" />
      <RequestCdTable data={cases} />
    </>
  );
};
